/*
  Usage : DynamicLoader(import(component))
  用于动态加载组件
*/
import Loadable from 'react-loadable';
import Loading from "./Loading";
export default function DynamicLoader(Component) {
    return Loadable({
        loader: Component,
        loading: Loading,
        delay: 200,
        timeout: 10000
    });
}
